import React, { useState } from "react";
import styles from "./position.module.scss";
import BigRapolasLogo from "../logo/bigRapolasLogo.tsx";

interface Props {
  dateFrom: string;
  dateTo: string;
  positionName: string;
  description: string;
  imageLocation: string;
  jobUrl: string;
}

const Position: React.FC<Props> = (props) => {
  return (
    <div className={styles.positionLayout}>
      <div className={styles.positionBody}>
        <div className={styles.positionHeader}>
          <div>
            {props.dateFrom} - {props.dateTo}
          </div>
          <div>{props.positionName}</div>
        </div>
        <div className={styles.positionDescription}>{props.description}</div>
      </div>
      <div className={styles.logotipas}>
        {!!props.imageLocation ? (
          <img
            onClick={() => window.open(props.jobUrl, "_blank")}
            src={props.imageLocation}
            alt="Logo"
            width="160"
            height="120"
          ></img>
        ) : (
          <BigRapolasLogo />
        )}
      </div>
    </div>
  );
};
export default Position;
